"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var layout_1 = require("../layout");
var Timeline = /** @class */ (function (_super) {
    __extends(Timeline, _super);
    function Timeline(props) {
        return _super.call(this, props) || this;
    }
    Timeline.prototype.render = function () {
        var _this = this;
        var pathColor = function () {
            if (_this.props.pathColor) {
                return React.createElement("section", { className: "path-color", style: { border: '5px solid ' + _this.props.pathColor } });
            }
            return null;
        };
        return (React.createElement(layout_1.Wrapper, { key: "".concat(this.props.type, "-").concat(this.props.index), className: "activity-detail" },
            React.createElement(layout_1.Row, { justifyContent: "flex-start" },
                React.createElement("section", { className: 'icon-section ' + (this.props.lineClass || '') },
                    React.createElement("i", { className: "material-icons" }, this.props.icon)),
                React.createElement(layout_1.Margin, { margin: "12px" }),
                React.createElement(layout_1.Column, null,
                    React.createElement("div", null,
                        React.createElement("label", { className: "title ".concat(this.props.titleClass) }, this.props.title)),
                    React.createElement("div", null,
                        React.createElement("label", { className: "time" }, this.props.time),
                        this.props.label &&
                            React.createElement("label", { className: "label" },
                                this.props.label,
                                pathColor()))))));
    };
    return Timeline;
}(React.Component));
exports.default = Timeline;
